import Vue from 'vue';

const CONFIG = {
    // 落地页&首页
    home: {
        title: '',
        description: '',
        keywords: '',
    },
    
    // 解决方案
    serve: {
        title: '解决方案',
        description: '惠智采(SmartProcure)平台，一款专为采购人设计的全方位采购管理解决方案。我们致力于帮助您实现高效、智能的采购流程，从供应商管理到数据分析，提供一站式解决方案。',
        keywords: '惠智采,中惠科技,采购,招标,代理,采购人,专家,开标,评标',
    },
    // 采购信息
    notice: {
        title: '采购信息',
        description: '惠智采(SmartProcure)平台，一款专为采购人设计的全方位采购管理解决方案。我们致力于帮助您实现高效、智能的采购流程，从供应商管理到数据分析，提供一站式解决方案。',
        keywords: '惠智采,中惠科技,采购,招标,代理,采购人,专家,开标,评标',
    },
    // 新闻公告
    news: {
        title: '新闻公告',
        description: '惠智采(SmartProcure)平台，一款专为采购人设计的全方位采购管理解决方案。我们致力于帮助您实现高效、智能的采购流程，从供应商管理到数据分析，提供一站式解决方案。',
        keywords: '惠智采,中惠科技,采购,招标,代理,采购人,专家,开标,评标',
    },
    // 帮助中心
    help: {
        title: '帮助中心',
        description: '惠智采(SmartProcure)平台，一款专为采购人设计的全方位采购管理解决方案。我们致力于帮助您实现高效、智能的采购流程，从供应商管理到数据分析，提供一站式解决方案。',
        keywords: '惠智采,中惠科技,采购,招标,代理,采购人,专家,开标,评标',
    },
    // 关于我们
    about: {
        title: '关于我们',
        description: '惠智采(SmartProcure)平台，一款专为采购人设计的全方位采购管理解决方案。我们致力于帮助您实现高效、智能的采购流程，从供应商管理到数据分析，提供一站式解决方案。',
        keywords: '惠智采,中惠科技,采购,招标,代理,采购人,专家,开标,评标',
    },

}

export default CONFIG;

function stringReplace( str ,id='hzc'){
    if(id === 'hzc'){
        return str.replace(/惠智云采/g , '惠智采')
    }

    if(id === 'hzyc'){
        return str.replace(/惠智采/g , '惠智云采')
    }
};

export function buildTdk(name) {
    const item = CONFIG[name],
        res = {
            meta: [],
            webName: Vue.prototype.webInfo?.webName,
        };

    if (item.title) {
        res.title = item.title;
    }

    if (item.description) {
        res.meta.push({
            hid: 'description',
            name: 'description',
            content: stringReplace(item.description , Vue.prototype.webInfo.id),
        });
    }

    if (item.keywords) {
        res.meta.push({
            hid: 'keywords',
            name: 'keywords',
            content: stringReplace(item.keywords , Vue.prototype.webInfo.id),
        });
    }

    return res;
}